export default {
  bind(el, binding) {
    // 把 once 默认值改成 false，就实现“直接 v-fade-in 即可反复触发”
    const { delay = 0, threshold = 0.05, once = false } = binding.value || {};
    el.classList.add('fade-before');
    const io = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) {
          setTimeout(() => el.classList.add('fade-in'), delay);
          if (once) io.unobserve(el);   // 只有显式 once: true 才解绑
        } else if (!once) {
          el.classList.remove('fade-in');
        }
      },
      { threshold }
    );
    io.observe(el);
  }
};